import httpRequest from "./httpreq";
import { isFunction, isDefined, normalName, objectCopy, logStdout } from "../shared/utils";
import { formatDate } from "../shared/filters";
import { _DATEFORMATS } from "../shared/consts";
import fileSys from "../fileoprators/fileSystem";
import { deleteRecords, getAllRecordsOfPatientWithContent } from "./record";
export const addPatient = (pat, callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "addPatient",
    body: pat,
    token: window.token
  };
  logStdout("add patient", opt.body, window.session.user.username);
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result.patient = data.obj.patient;
    } else {
      result = {
        message: "failed",
        error: data.error || { code: "" }
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
    fileSys.syncDisk();
  });
};
export const countAllPatients = (callback) => {
  let opt = {
    cmd: "countAllPatients",
    token: window.token
  };
  let result = {
    message: "OK"
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result.count = data.obj.count;
      if (isFunction(callback)) {
        callback(result);
      }
    } else {
      result.message = "failed";
      if (isFunction(callback)) {
        callback(result);
      }
    }
  });
};
export const delPatient = (_id, callback, pat) => {
  let result = {
    message: "OK"
  };
  if (pat) {
    logStdout(
      "delete patient",
      { _id: _id, name: pat.firstname, pid: pat.pid },
      window.session.user.username
    );
  }
  getAllRecordsOfPatientWithContent(_id, {}, (data) => {
    if (data.message !== "OK") {
      result.message = "failed";
      if (isFunction(callback)) {
        callback(result);
      }
    } else {
      deleteRecords(data.records.concat(), (data) => {
        fileSys.syncDisk();
        if (data.message === "OK") {
          let opt = {
            cmd: "delPatient",
            body: {
              _id: _id
            },
            token: window.token
          };
          httpRequest(opt, (data) => {
            if (data.message !== "OK") {
              result = {
                message: "failed",
                error: data.error
              };
            }
            if (isFunction(callback)) {
              callback(result);
            }
          });
        } else {
          fileSys.syncDisk();
          result.message = "failed";
          if (isFunction(callback)) {
            callback(result);
          }
        }
      });
    }
  });
};

const delPatients = (pats = [], callback) => {
  let result = {
    message: "OK"
  };
  if (pats.length <= 0) {
    if (isDefined(callback)) {
      callback(result);
    }
  } else {
    let pat = pats.pop();
    logStdout("delete patient", pat, window.session.user.username);
    delPatient(pat, (data) => {
      if (data.message === "OK") {
        delPatients(pats, callback);
      } else {
        if (isFunction(callback)) {
          result = {
            message: "failed",
            failedPatient: pat
          };
          callback(result);
        }
      }
    });
  }
};
export const reloadPatientDB = (callback) => {
  let opt = {
    cmd: "reloadPatients",
    token: window.token
  };

  httpRequest(opt, (data) => {
    if (isFunction(callback)) {
      callback(data);
    }
  });
};
export const getOnePatient = (options = { matchall: false, search: {} }, callback) => {
  const { search, matchall } = options;
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "getOnePatient",
    body: {
      search: search,
      matchall: matchall
    },
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result.patient = data.obj.patient;
    } else {
      result = data;
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
export const getAllPatients = (
  options = {
    page: 1,
    pagelength: 14,
    sort: { key: "creationdate", asc_desc: -1 },
    matchall: false
  },
  patients = [],
  callback
) => {
  const { sort, search, page, matchall, pagelength, dateRange } = options;
  let opt = {
    cmd: "getPatients",
    body: {
      page: page,
      pagelength: pagelength,
      search: search,
      sort: sort,
      matchall: matchall,
      dateRange: dateRange
    },
    token: window.token
  };

  httpRequest(opt, (res) => {
    if (res.message === "OK") {
      if (res.obj.patients.length >= options.pagelength) {
        patients = patients.concat(res.obj.patients);
        options.page += 1;
        getAllPatients(options, patients, callback);
      } else {
        patients = patients.concat(res.obj.patients);
        if (callback) callback(null, patients);
      }
    } else {
      if (callback) callback(res.error);
    }
  });
};
export const getPatients = (
  options = {
    page: 1,
    pagelength: 14,
    sort: { key: "creationdate", asc_desc: -1 },
    matchall: false
  },
  callback
) => {
  const { sort, search, page, matchall, pagelength, dateRange } = options;
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "getPatients",
    body: {
      page: page,
      pagelength: pagelength,
      search: search,
      sort: sort,
      matchall: matchall,
      dateRange: dateRange
    },
    token: window.token
  };

  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      if (isFunction(callback)) {
        result.patients = data.obj.patients;
        result.allPatientsCount = data.obj.allcount;
      }
    } else {
      if (isFunction(callback)) {
        result = {
          message: "falied",
          error: data.error
        };
      }
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
export const updatePatient = (pat, callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "updatePatient",
    body: pat,
    token: window.token
  };
  logStdout("update patient", opt.body, window.session.user.username);
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result.patient = pat;
    } else {
      result = {
        message: "failed",
        error: data.error
      };
    }
    fileSys.syncDisk();
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
export const initPatientCfg = () => {
  return objectCopy(window.languages[window.settings.language].patientcfg);
};
export const initHeaders = () => {
  let _patientHeaders = [];
  let patientCfg = objectCopy(window.languages[window.settings.language].patientcfg);
  for (let key in patientCfg) {
    if (patientCfg[key].display) {
      let header = {
        prop: key,
        label: patientCfg[key]["title"],
        width:
          key === "sex"
            ? window.settings.language === "de"
              ? 140
              : window.settings.language === "it"
                ? 155
                : 120
            : undefined
      };
      _patientHeaders.push(header);
    }
  }
  _patientHeaders.push({
    prop: "creationdate",
    label: "txtCreationDate"
  });
  return _patientHeaders.concat();
};
const procData = (pat, cfg, key, dfmt) => {
  switch (key) {
    // case 'firstname':
    //   return normalName(pat.firstname, pat.lastname)
    case "sex":
      return cfg["sexes"][pat[key]];
    case "creationdate":
    case "birthday":
      return formatDate(pat[key], dfmt);
  }
  return pat[key];
};
export const normalPatient = (id, patient) => {
  let patientCfg = window.languages[window.settings.language].patientcfg;
  let _patient = {
    index: id,
    _id: patient._id,
    creationdate: patient.creationdate
  };
  let headers = initHeaders();
  for (let idy in headers) {
    let key = headers[idy].prop;
    _patient[key] = procData(
      patient,
      patientCfg[key],
      key,
      _DATEFORMATS[window.settings.dateFormat].label
    );
  }
  _patient["creationdate"] = procData(
    patient,
    {},
    "creationdate",
    _DATEFORMATS[window.settings.dateFormat].label
  );
  return _patient;
};
export const normalPatients = (patients) => {
  let _patients = [];
  for (let id = 0; id < patients.length; id++) {
    _patients.push(normalPatient(id, patients[id]));
  }
  return _patients;
};
export const exportGetPatientsAll = (page, pageLength, search, callback) => {
  search = search || {};

  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "exportGetPatientsAll",
    body: {
      page: page,
      pageLength: pageLength,
      search: search
    },
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result = data.obj;
    } else {
      result = {
        message: "failed",
        error: data.error
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};

export const exportPath = (
  path,
  getExportRecords,
  patients,
  records,
  exportType,
  recordAllDetails,
  topographyOriginalObj,
  callback
) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "exportPath",
    body: {
      path: path,
      getExportRecords: getExportRecords,
      patients: patients,
      records: records,
      exportType: exportType,
      recordAllDetails: recordAllDetails,
      topographyOriginalObj: topographyOriginalObj
    },
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result = data;
    } else {
      result = {
        message: "failed",
        error: data.error
      };
    }
    callback(result);
  });
};

export const exportGetPatientsAllData = (callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "exportGetPatientsAllData",
    body: {},
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result = data;
    } else {
      result = {
        message: "failed",
        error: data.error
      };
    }
    callback(result);
  });
};



// WEBPACK FOOTER //
// ./src/services/patient.js